// Vendor Libraries

try {
  window.$ = window.jQuery = require("jquery");
  window.Selectric = require("jquery-selectric");

  var isIE11 =
    !!window.MSInputMethodContext && !!document.documentMode
      ? "is-ie"
      : "is-not-ie";
  $("html").removeClass("no-js").addClass("is-loaded").addClass(isIE11);
} catch (e) {
  console.log(e);
}

jQuery(document).ready(function ($) {
  // Components
  require("./components/utilities");
  require("./components/animation");
  require("./components/colorbox");
  require("./components/disclaimer");
  require("./components/downloadCSV");
  require("./components/lazyLoad");
  require("./components/locationsFilters");
  require("./components/plugins");
  require("./components/portfolioFilters");
  require("./components/postFilters");
  require("./components/scrollTracker");
  require("./components/teamFilters");
  require("./components/selectric");
  require("./components/ada");
  require("./components/canary");

  // Blocks
  require("./blocks/accordion");
  require("./blocks/box-list");
  require("./blocks/content-box");
  require("./blocks/event");
  require("./blocks/interactive-graphic");
  require("./blocks/leadership");
  require("./blocks/link-list");
  require("./blocks/locations");
  require("./blocks/map");
  require("./blocks/masthead");
  require("./blocks/responsive-slider");
  require("./blocks/simplemap");
  require("./blocks/stats");
  require("./blocks/tabs");
  require("./blocks/team");
  require("./blocks/wp-menu");
});
